module.exports = __webpack_public_path__ + "static/media/code_import_screenshot.c9c689f7.png";